<template>
    <div class="container">
        <div class="c_top">
            <img style="width: 44px; height: 44px; margin-top: 13px; margin-left: 20px;" src="../../assets/icon_miyou.png" />
            <div class="top_title">
                <span style="font-size: 16px; font-weight: 500; margin-top: 10px;">泛娱乐</span>
                <span style="font-size: 14px; margin-top: 2px;">娱乐交友，应有尽有</span>
            </div>
            <div style="flex: 1"></div>
            <div class="top_btn" @click="goDownload">
                <span style="font-size: 14px; color: white;">下载App</span>
            </div>
        </div>

        <div class="animate-wave">
            <div class="w1"></div>
            <div class="w2"></div>
            <div class="w3"></div>
            <div class="w4"></div>
            <div class="w5"></div>
            <div class="w6"></div>
        </div>
        <div id="cover" class="c_cover" :style="cover"></div>

        <div style="font-size: 18px; font-weight: 800; color: white; margin-top: 100px;">{{ name }}</div>
        <div style="font-size: 16px; color: white; margin-top: 26px;">邀请你加入聊天室：{{ name }}</div>
        <div v-if="isOpen" style="font-size: 16px; color: white; margin-top: 16px; display: flex; align-items: center;">
            <img style="width: 34px; height: 24px" src="../../assets/common/audio_wave.gif" />
            <span style="margin-left: 10px;"> {{ num }}人热聊中</span>
        </div>
        <div v-else style="font-size: 16px; color: white; margin-top: 16px; display: flex; align-items: center;">
            <span style="margin-left: 10px;">该房间暂未开播</span>
        </div>

        <div class="c_bottom" @click="goDownload">
            加入聊天
        </div>
    </div>
</template>


<script>
import { prefix, prefix_dev, webRoomInfo } from '../profit/url';
import axios from 'axios';

const packageName = "com.flow.mimi";

export default ({
    data() {
        return {
            name: "花店名我自己想",
            num: 298,
            isOpen: true,
            cover: '',
            urlPrefix: prefix,
        };
    },

    created() {
        // this.cover = "background-image: url(https://q8.itc.cn/q_70/images03/20240517/71b47444c2aa467eb464c633b088bc87.jpeg)";
        this.getRoomInfo();
    },

    methods: {
        getRoomInfo() {
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            let room_num = '-1';
            let is_dev = false;
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })
                room_num = p.id;
                is_dev = p.dev == 1;
            } catch(e) { }

            const requestPrefix = !is_dev ? prefix_dev : prefix;
            const requestUrl = requestPrefix + webRoomInfo + "?room_num=" + room_num;
            axios.get(requestUrl).then(res => {
                const data = res.data;
                this.name = data.room_name;
                this.cover = "background-image: url(" + data.room_cover + ");";
                this.num = data.online_num;
                this.isOpen = data.open_state == 1;
                // console.log('user data user data si - -- --- ---->', res.data);
            }).catch(err => { });
        },

        goDownload() {
            if (this.is_neizhi()) {
                alert("请点击右上角用外部浏览器打开");
                return;
            }

            const iosLinkUrl = "https://www.qq.com";
            const androidLinkUrl = "https://www.baidu.com";
            const huaweiUrl = "appmarket://details?id=" + packageName;
            const oppoUrl = "oppomarket://details?packagename=" + packageName;
            const vivoUrl = "vivomarket://details?id=" + packageName;
            const xiaomiUrl = "mimarket://details?id=" + packageName;
            switch(this.verifyBrand()) {
                case "iphone":
                    window.location.href = iosLinkUrl;
                    break;

                case "xiaomi":
                    window.location.href = xiaomiUrl;
                    break;

                case "huawei":
                    window.location.href = huaweiUrl;
                    break;

                case "vivo":
                    window.location.href = vivoUrl;
                    break;

                case "oppo":
                    window.location.href = oppoUrl;
                    break;

                default:
                    window.location.href = androidLinkUrl;
                    break;
            }
        },

        verifyBrand() {
            const userAgent = navigator.userAgent.toLowerCase();
            const isIphone = userAgent.match(/(iphone|ipad|ipod)/i);
            const isHuawei = userAgent.match(/huawei/i);
            const isHonor = userAgent.match(/honor/i);
            const isOppo = userAgent.match(/oppo/i);
            const isOppoR15 = userAgent.match(/PACM00/i);
            const isVivo = userAgent.match(/vivo/i);
            const isXiaomi = userAgent.match(/mi\s/i);
            const isXIAOMI = userAgent.match(/xiaomi/i);
            const isXiaomi2s = userAgent.match(/mix\s/i);
            const isRedmi = userAgent.match(/redmi/i);

            if (isIphone) {
                return "iphone";
            } else if (isHuawei || isHonor) {
                return "huawei";
            } else if (isOppo || isOppoR15) {
                return "oppo";
            } else if (isVivo) {
                return "vivo";
            } else if (isXiaomi || isRedmi || isXiaomi2s || isXIAOMI) {
                return "xiaomi";
            } else {
                return "other";
            }
        },

        is_neizhi() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return "weixin";
            } else if (ua.match(/QQ/i) == "qq") {
                return "QQ";
            } else if (ua.match(/Alipay/i) == "alipay") {
                return "alipay";
            }

            return false;
        },
    }
})
</script>


<style scoped>
.container {
    width: 100vw;
    height: 100vh;
    background-image: url(../../assets/common/audio_room_share_bg.png);
    background-size: cover;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.c_top {
    width: 100vw;
    height: 70px;
    background-color: rgba(255, 233, 233, 0.30);
    position: fixed;
    top: 0px;
    display: flex;
}
.top_title {
    width: 50vw;
    height: 70px;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    color: white;
}
.top_btn {
    width: 80px;
    height: 30px;
    border-radius: 15px;
    margin-right: 16px;
    margin-top: 20px;
    background: linear-gradient(#FFACAC, #FF81C3);
    align-items: center;
    justify-content: center;
    display: flex;
}

.c_cover {
    width: 130px;
    height: 130px;
    top: 170px;
    position: absolute;
    background-color: pink;
    /* background-image: url(https://q8.itc.cn/q_70/images03/20240517/71b47444c2aa467eb464c633b088bc87.jpeg); */
    background-size: cover;
    border-radius: 50%;
}

.c_bottom {
    width: 80vw;
    height: 50px;
    border-radius: 10px;
    margin-top: 30px;
    background: linear-gradient(#FFACAC, #FF81C3);
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 18px;
    color: white
}


.animate-wave {
    width: 280px;
    height: 280px;
    position: relative;
    top: 95px;
    left: 0;
    right: 0;
    margin: 0 auto;
}

@-webkit-keyframes opac {
    from {
        opacity: 1;
        width: 0;
        height: 0;
        top: 50%;
        left: 50%;
    }
    to {
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
}

.animate-wave * {
    background: rgb(148, 131, 168);
    position: absolute;
    border-radius: 50%;
    animation: opac 6s infinite;
}
.animate-wave .w2 {
    animation-delay: 2s;
}
.animate-wave .w3 {
    animation-delay: 3s;
}
.animate-wave .w4 {
    animation-delay: 4s;
}
.animate-wave .w5 {
    animation-delay: 5s;
}
.animate-wave .w6 {
    animation-delay: 6s;
}
</style>